import SEO from '../components/SEO';

const PrivacyPolicyPage = () => (
  <main className="bg-surface min-h-screen">
    <SEO
      title="Privacy Policy | Aspire Academy & MathMap"
      description="Privacy policy for Aspire Academy and MathMap — how we collect, use, and protect your data."
      path="/privacy-policy"
    />

    <div className="container-main py-16 md:py-24 max-w-3xl">
      <span className="label-uppercase text-aspire-red">Legal</span>
      <h1 className="heading-hero mt-2 mb-4">Privacy Policy</h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: April 2025</p>

      <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">1. Who We Are</h2>
          <p>
            This Privacy Policy applies to <strong>Aspire Academy</strong> (aspireacademy.com.lk) and its
            associated digital products, including <strong>MathMap</strong> — an interactive learning tool
            for IGCSE and A Level Mathematics. Together these are referred to as "we", "us", or "our services".
          </p>
          <p className="mt-2">
            Our registered address is 102/5A, Srimath Anagarika Dharmapala Mawatha, Colombo 00700, Sri Lanka.
            For privacy enquiries contact us at <a href="mailto:info@aspireacademy.com.lk" className="text-aspire-red hover:underline">info@aspireacademy.com.lk</a>.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">2. Information We Collect</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Account information:</strong> name, email address, and password when you register.</li>
            <li><strong>Contact form submissions:</strong> name, email, phone number, and message content.</li>
            <li><strong>Learning data (MathMap):</strong> quiz scores, topic progress, and session activity to personalise your experience.</li>
            <li><strong>Usage analytics:</strong> pages visited, time on site, device type, and general location (country/city level) via PostHog and Vercel Analytics. No personally identifiable information is included.</li>
            <li><strong>Payment information:</strong> processed securely by our payment provider. We do not store card details.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">3. How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To create and manage your account.</li>
            <li>To deliver and personalise MathMap learning content.</li>
            <li>To respond to enquiries submitted via our contact form.</li>
            <li>To send important service updates (not marketing, unless you opt in).</li>
            <li>To improve our website and products using anonymised analytics.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">4. Data Sharing</h2>
          <p>We do not sell or rent your personal data. We share data only with:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li><strong>Supabase</strong> — our database and authentication provider (data stored in EU region).</li>
            <li><strong>Vercel</strong> — hosting and analytics infrastructure.</li>
            <li><strong>PostHog</strong> — anonymised product analytics.</li>
            <li>Legal authorities if required by law.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">5. Data Retention</h2>
          <p>
            We retain your account data for as long as your account is active. Contact form submissions are
            retained for up to 12 months. You may request deletion at any time by emailing us.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Access the personal data we hold about you.</li>
            <li>Request correction of inaccurate data.</li>
            <li>Request deletion of your account and associated data.</li>
            <li>Withdraw consent for optional communications at any time.</li>
          </ul>
          <p className="mt-2">To exercise these rights, email <a href="mailto:info@aspireacademy.com.lk" className="text-aspire-red hover:underline">info@aspireacademy.com.lk</a>.</p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">7. Cookies</h2>
          <p>
            We use essential cookies to maintain your login session. Analytics cookies (PostHog, Vercel)
            collect anonymised usage data. No advertising or tracking cookies are used.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">8. Changes to This Policy</h2>
          <p>
            We may update this policy periodically. Material changes will be communicated via email or a
            notice on our website. Continued use of our services after changes constitutes acceptance.
          </p>
        </section>

      </div>
    </div>
  </main>
);

export default PrivacyPolicyPage;
